import { useSelector } from 'react-redux';
import { getHasFirstPayment } from '../authSlice/authSelectors';

export function useHasFirstPayment(): boolean {
  const hasFirstPayment = useSelector(getHasFirstPayment);
  return hasFirstPayment;
}
